import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { RoomList } from "@/components/features/items/list/room";

import { useGetPlanListPageParams } from "../../plan/list/_hooks/use-get-plan-list-page-params";

export const RoomListPage = () => {
	const { hotelID } = useGetPlanListPageParams();

	return (
		<PageMeta title="部屋の一覧" url={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })}>
			<RoomList hotelID={hotelID} />
		</PageMeta>
	);
};

RoomListPage.displayName = "RoomListPage";
